var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}



document.getElementById('c2').style.display='none';
document.getElementById('c3').style.display='none';



function changeTab(id){
    if(id == 'tab1'){
        document.getElementById('tab1').classList.add('tab-nav');
        document.getElementById("tab2").classList.remove('tab-nav');
        document.getElementById('tab3').classList.remove('tab-nav');
        document.getElementById('c1').style.display='block';
        document.getElementById('c2').style.display='none';
        document.getElementById('c3').style.display='none';
    }
    if(id == 'tab2'){
        document.getElementById('tab2').classList.add('tab-nav');
        document.getElementById("tab1").classList.remove('tab-nav');
        document.getElementById("tab3").classList.remove('tab-nav');
        document.getElementById('c2').style.display='block';
        document.getElementById('c1').style.display='none';
        document.getElementById('c3').style.display='none';
    }
    if(id == 'tab3'){
        document.getElementById('tab3').classList.add('tab-nav');
        document.getElementById("tab1").classList.remove('tab-nav');
        document.getElementById("tab2").classList.remove('tab-nav');
        document.getElementById('c3').style.display='block';
        document.getElementById('c1').style.display='none';
        document.getElementById('c2').style.display='none';
    }
}

document.getElementById('faq1_ans').style.display='none';
document.getElementById('faq1_au').style.display='none';
document.getElementById('faq2_ans').style.display='none';
document.getElementById('faq2_au').style.display='none';
document.getElementById('faq3_ans').style.display='none';
document.getElementById('faq3_au').style.display='none';
